import apiClient from '../lib/apiClient';

const invoiceService = {
  // Get all invoices with optional filters
  getInvoices: async (filters = {}) => {
    try {
      const result = await apiClient.get('/invoices', filters);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch invoices' };
    }
  },

  // Get invoice by ID
  getInvoice: async (invoiceId) => {
    try {
      const result = await apiClient.get(`/invoices/${invoiceId}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch invoice details' };
    }
  },

  // Create new invoice
  createInvoice: async (invoiceData) => {
    try {
      const result = await apiClient.post('/invoices', invoiceData);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to create invoice' };
    }
  },

  // Update invoice
  updateInvoice: async (invoiceId, updateData) => {
    try {
      const result = await apiClient.put(`/invoices/${invoiceId}`, updateData);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to update invoice' };
    }
  },

  // Delete invoice
  deleteInvoice: async (invoiceId) => {
    try {
      const result = await apiClient.delete(`/invoices/${invoiceId}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to delete invoice' };
    }
  },

  // Get invoice statistics
  getInvoiceStats: async () => {
    try {
      const result = await apiClient.get('/invoices/stats');
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch invoice statistics' };
    }
  },

  // Send invoice (update status to sent)
  sendInvoice: async (invoiceId) => {
    try {
      const result = await apiClient.post(`/invoices/${invoiceId}/send`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to send invoice' };
    }
  },

  // Get analytics data
  getAnalytics: async () => {
    try {
      const result = await apiClient.get('/invoices/analytics');
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch analytics' };
    }
  }
};

// Invoice number generation is handled by backend

export default invoiceService;